var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "nav-link",
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList")
      }
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.wishListCount))]),
      _vm._v(" "),
      _c("i", {
        staticClass: "fa",
        class: {
          "fa-thumb-tack": !_vm.wishListCount,
          "fa-thumb-tack": _vm.wishListCount
        },
        attrs: { "aria-hidden": "true" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }